import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { TradeWorkflowSpecStore } from '@pinnakl/poems/trade-workflow-spec/data-access';
import { hasEmsV3Access } from '@pinnakl/poems/trade-workflow-spec/domain';

export const checkEmsV3Access: CanMatchFn = async () => {
  const router = inject(Router);
  const tradeWorkflowSpecStore = inject(TradeWorkflowSpecStore);

  const spec = await tradeWorkflowSpecStore.ensureLoaded();
  return hasEmsV3Access(spec) ? true : router.parseUrl('/ems');
};
